let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ljaqI")).then(() => parcelRequire('hP5xt'));